<cm-sidebar-layout>
    <cm-item-filters cm-filters>
        <cm-tag-search-filter></cm-tag-search-filter>
        <cm-checkboxes-filter label="User Type" name="isStaff" [options]="Labels.IsStaff"></cm-checkboxes-filter>
        <cm-checkboxes-filter label="Onboarding" name="onboardingCompleted" [options]="Labels.Completed"></cm-checkboxes-filter>
        <cm-checkboxes-filter label="Account Type" name="accountType" [options]="Labels.AccountType"></cm-checkboxes-filter>
        <cm-checkboxes-filter label="Status" name="includeInactive" [options]="Labels.IncludeInactive"></cm-checkboxes-filter>
    </cm-item-filters>
    <cm-users-grid></cm-users-grid>
</cm-sidebar-layout>
<router-outlet></router-outlet>
